<template>
    <div>
        <loading-overlay />
        <error-modal />
        <navbar />
        <off-canvas />
        <div class="app-layout">
            <transition
                name="fade"
                mode="out-in"
                appear
            >
                <router-view />
            </transition>
            <generic-footer />
        </div>
    </div>
</template>

<script>
const Navbar = () => import("./generic/Navbar");
const OffCanvas  = () => import( "./generic/OffCanvas");
const ErrorModal  = () => import( "@strangeanimals/common-vue-components/src/components/modals/ErrorModal");
const LoadingOverlay  = () => import( "@strangeanimals/common-vue-components/src/components/page/LoadingOverlay");
const GenericFooter  = () => import( "./generic/GenericFooter");
export default {
    components: { GenericFooter, LoadingOverlay, ErrorModal, OffCanvas, Navbar }
};
</script>

<style lang="scss">
    @import "../scss/base.scss";
    @import "~uikit/src/scss/uikit.scss";
    @import "../scss/site.scss";

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
</style>
